import React from 'react';
import { Icon, Badge } from '@burna/monster-design-system';
import RowItem from 'components/row-item';
import styles from './index.module.scss';

const RowItemScanList = ({ data, outOfTime }) => {
  return (
    <div className={styles.list}>
      {data.map((item, index) => (
        <RowItem
          key={index}
          title={item.avName}
          imgSrc={
            !['avast', 'windowsdefender'].includes(item.avName)
              ? `/scanner/applications/${item.avName}.png`
              : '/scanner/applications/unknown.png'
          }>
          <RowItem.Actions>
            <RowItem.Action>
              {outOfTime && item.progress === 'loading' ? (
                <Badge type="error" icon="alert-circle" label="Error" />
              ) : (
                <Badge
                  type={
                    item.malwareState === 'unknown'
                      ? 'warning'
                      : item.malwareState === 'clean'
                      ? 'success'
                      : 'error'
                  }
                  icon={
                    item.malwareState === 'unknown'
                      ? 'loader:spin'
                      : item.malwareState === 'clean'
                      ? 'check'
                      : 'x'
                  }
                  label={
                    item.malwareState === 'unknown'
                      ? 'Checking'
                      : item.malwareState === 'clean'
                      ? 'Scanned'
                      : 'Failed'
                  }
                />
              )}
            </RowItem.Action>
          </RowItem.Actions>
          <RowItem.Content>
            {outOfTime && item.progress === 'loading' ? (
              <RowItem.ContentItem title="Time out">
                <Icon type="alert-triangle" className={styles.icon} />
              </RowItem.ContentItem>
            ) : (
              <>
                {item.malwareState === 'malware' ? (
                  <RowItem.ContentItem
                    title={item.malwareName}></RowItem.ContentItem>
                ) : null}
              </>
            )}
          </RowItem.Content>
        </RowItem>
      ))}
    </div>
  );
};

export default RowItemScanList;
